<template>
  <v-card variant="outlined" class="mb-4" :class="[{ old: isOld }, getSaleClass(order)]">
    <v-row class="pa-4">
      <v-col cols="12" md="6">
        <div class="d-flex align-center align-self-start" style="justify-content: space-between;">
          <v-checkbox
            :model-value="selected"
            @update:model-value="$emit('selection-changed', orderData.ID)"
            hide-details
          ></v-checkbox>
          <a
            :href="`/sales/${orderData.ID}`"
            color="primary"
          >
            {{ orderData.ID }}
          </a>
          <a
            :href="marketplaceUrl"
            class="text-decoration-none"
            target="_blank"
          >
            {{ orderData.listingid }}
          </a>
          {{ orderData.PONumber }}
          <a 
            :href="`mailto:${orderData.BuyerEmail}`"
            class="text-decoration-none"
          >
            {{ orderData.BuyerID }}
          </a>
        </div>
        <div class="d-flex align-center align-self-start" style="justify-content: space-between;">
          <v-chip v-if="orderData.ebayprice == 0" variant="elevated" color="error" class="pa-2">
            <div style="font: 14px; font-weight: 600;">Sale ${{ orderData.ebayprice }}</div>
          </v-chip>
          <editable-field
            v-else
            v-model="orderData.ebayprice"
            label="Sale"
            type="number"
            :loading="loading"
            is-currency
            class="mr-2"
            readonly
          />
          <editable-field
            v-model="orderData.quantity"
            label="Qty"
            type="number"
            :loading="loading"
            class="mr-2"
            readonly
          />
          <editable-field
            v-model="orderData.ActualMyCost"
            label="Cost"
            type="number"
            :loading="loading"
            is-currency
            class="mr-2"
            :style="orderData.ActualMyCost == 0 ? 'background-color: yellow; border-radius: 8px; padding: 0 5px;' : ''"
            @edit-complete="handleFieldUpdate"
          />

          <editable-field
            v-model="orderData.ActualShipping"
            label="Shipping"
            type="number"
            :loading="loading"
            is-currency
            @edit-complete="handleFieldUpdate"
            class="mr-2"
          />
          <template v-if="marketplace === 'Amazon'">
            <editable-field
              v-model="orderData.amazonfees"
              label="Amazon Fees"
              type="number"
              :loading="loading"
              is-currency
              @edit-complete="handleFieldUpdate"
              class="mr-2"
            />
        </template>
        <template v-else>
            <editable-field
              v-model="orderData.ebayfees"
              :label="`${marketplace} Fees`"
              type="number"
              :loading="loading"
              is-currency
              @edit-complete="handleFieldUpdate"
              mr-2
            />
        </template>
        <v-chip variant="elevated" :color="profit > 0 ? 'success' : 'error'">
          <div style="font: 14px; font-weight: 600;">Profit ${{ profit.toFixed(2) }}</div>
            <v-icon
              :icon="profit > 0 ? 'mdi-arrow-up' : 'mdi-arrow-down'"
            ></v-icon>
        </v-chip>
      </div>
      <div class="d-flex align-center">
        <editable-field
          v-model="orderData.itemnumber"
          label="Item Number"
          :loading="loading"
          @edit-complete="handleFieldUpdate"
          style="display: inline-block; width: 100%;"
          class="mt-2"
        />
        <span style="text-wrap: nowrap;">Stock Qty: {{ orderData.StockQuantity == null ? 'N/A' : orderData.StockQuantity }} </span>
      </div>
        <div class="d-flex align-center" v-if="!['ebay', 'cpw', 'am_auto', 'partscontainer'].includes(vendor)">
          <span v-if="orderData.ebayStore" class="mr-2 mt-2">{{ orderData.ebayStore }}</span>
          <span v-if="orderData.ebayItemId" class="mr-2 mt-2">{{ orderData.ebayItemId}}</span>
          
        </div>
      </v-col>
      <v-col cols="12" md="4">
        <div class="text-caption text-medium-emphasis">Shipping Address</div>
        <editable-field
          v-model="orderData.shippingname"
          label="Shipping Name"
          :loading="loading"
          hide-label
          @edit-complete="handleFieldUpdate"
          class="mt-2"
        />
        <editable-field
          v-model="orderData.shippingstreet1"
          label="Shipping Street 1"
          :loading="loading"
          hide-label
          @edit-complete="handleFieldUpdate"
          class="mt-2"
        />
        <editable-field
          v-model="orderData.shippingstreet2"
          label="Shipping Street 2"
          :loading="loading"
          hide-label
          class="mt-2"
          @edit-complete="handleFieldUpdate"
        />
        <editable-field
          v-model="orderData.phone"
          label="Phone"
          :loading="loading"
          hide-label
          class="mt-2"
          @edit-complete="handleFieldUpdate"
        />
      </v-col>
      <v-col cols="12" md="2">
        <div class="text-caption text-medium-emphasis">&nbsp;</div>
        <editable-field
          v-model="orderData.city"
          label="City"
          :loading="loading"
          hide-label
          class="mt-2"
          @edit-complete="handleFieldUpdate"
        />
        <editable-field
          v-model="orderData.state"
          label="State"
          :loading="loading"
          hide-label
          class="mt-2"
          @edit-complete="handleFieldUpdate"
        />
        <editable-field
          v-model="orderData.zip"
          label="Zip"
          :loading="loading"
          hide-label
          class="mt-2"
          @edit-complete="handleFieldUpdate"
        />
        <editable-field
          v-model="orderData.country"
          label="Country"
          hide-label
          class="mt-2"
          readonly
        />
      </v-col>
    </v-row>
    
    <v-row  class="px-4" no-gutters align="center" v-if="['ebay', 'cpw', 'am_auto', 'partscontainer'].includes(vendor)">
      <v-col cols="12" md="6"  class="px-2">
        <div class="d-flex align-center">
        <span class="mr-2">{{ orderData.ebayStore }}</span>
        <span class="mr-2">{{orderData.alternateItemId1}}</span>
        <span class="mr-2">{{orderData.alternateItemId2}}</span>
        <v-checkbox
          v-model="orderData.checked"
          @update:model-value="handleCheckedChange"
          hide-details
          density="compact"
          :loading="updating"
          label="Checked"
        ></v-checkbox>
        </div>
      </v-col>
      <v-col cols="12" md="3">
        <editable-field
          v-model="partNumber"
          label="New Part Number"
          :loading="assigning"
          style="min-width: 150px;"
          class="mr-2"
        />
      </v-col>
      <v-col cols="12" md="3" class="px-2">
        <div class="d-flex align-center">
          <v-spacer></v-spacer>
          <v-select
          v-model="newVendor"
          :items="vendorsList"
          item-title="vendor"
          item-value="slug"
          style="max-width: 150px;"
          class="mr-2"
          label="New Vendor"
        />
        <v-btn
         v-if="vendorsList.length > 0"
          @click="assignEbayOrderToVendor"
          color="success"
          class="mr-2"
        >
          Assign
        </v-btn>
        </div>
      </v-col>
    </v-row>
    <v-row v-else class="px-4" no-gutters align="center">
      <v-col cols="12" md="6"  class="px-2">
        
      </v-col>
    </v-row>
    <v-row class="px-4 pb-4 mt-2" no-gutters align="center">
      <v-col cols="12" md="9" class="pa-2">
        <v-text-field
          v-model="orderData.Note"
          label="Note"
          :disabled="loading"
          @keyup.enter="handleFieldUpdate"
          @blur="handleFieldUpdate"
        />
      </v-col>
      
      <v-col cols="12" md="3">
        <div class="d-flex align-center">
        <v-spacer></v-spacer>
        <v-btn
          :to="`/sales/${orderData.ID}/message`"
          color="primary"
        >
          Send Message
        </v-btn>
      </div>
      </v-col>
    </v-row>
    <v-row  class="px-4" no-gutters v-if="order.buyermessage">
      <v-col class="pa-2">
        <div>{{ order.buyermessage }}</div>
      </v-col>
    </v-row>
  </v-card>
</template>

<script setup>
import { ref, computed, defineProps, defineEmits, onMounted } from 'vue'
import { salesService } from '@/services/salesService'
import EditableField from '@/components/common/EditableField.vue'
import { getSaleClass } from '@/utils/SaleClass'
import { orderService } from '@/services/orderService'
import { useRoute } from 'vue-router'
import { useVendorsStore } from '@/stores/vendorsStore'
import { useStoresStore } from '@/stores/storesStore'
import { isEBayVendor } from '@/utils/helpers'
const props = defineProps({
  order: {
    type: Object,
    required: true
  },
  selected: {
    type: Boolean,
    default: false
  }
})

const route = useRoute()
const vendorsStore = useVendorsStore()
const storesStore = useStoresStore()
const emit = defineEmits(['update-error', 'selection-changed', 'order-assigned'])

// Local state
const loading = ref(false)
const orderData = ref({
  ...props.order,
  checked: props.order.checked === 1
})
const updating = ref(false)

const handleCheckedChange = async () => {
  updating.value = true
  try {
    await orderService.updateCheckedStatus(props.order.ID, orderData.value.checked)
  } catch (err) {
    console.error('Error updating checked status:', err)
    orderData.value.checked = !orderData.value.checked // Revert on error
  } finally {
    updating.value = false
  }
}

const vendor = ref(route.params.vendor)
const partNumber = ref(isEBayVendor(props.order.vendor) ? props.order.alternateItemId1 : props.order.alternateItemId2)
const newVendor = ref('')
const marketplace = computed(() => storesStore.getStoreBySlug(props.order.Site).marketplace)

const vendorsList = computed(() => {
  switch (vendor.value) {
    case 'am_auto':
      return ['ebay', 'trq', 'pa', 'fa', 'pf', 'fairchild'].map(vendor => vendorsStore.getVendorBySlug(vendor))
    case 'cpw':
      return ['ebay', 'pf', 'pa', 'fa'].map(vendor => vendorsStore.getVendorBySlug(vendor)) 
    case 'partscontainer':
      return ['ebay', 'pa'].map(vendor => vendorsStore.getVendorBySlug(vendor))
    default:
      return []
  }
})

onMounted(() => {
  switch (vendor.value) {
    case 'am_auto':
      newVendor.value = 'trq'
      break
    case 'cpw':
      newVendor.value = 'pf'
      break
    case 'partscontainer':
      newVendor.value = 'pa'
      break
    default:
      newVendor.value = ''
  }
})

// Computed
const profit = computed(() => {
  const o = orderData.value
  const price = Number(o.ebayprice) || 0
  const shipping = Number(o.shipping) || 0
  const actualShipping = Number(o.ActualShipping) || 0
  const cost = Number(o.ActualMyCost) || 0
  const amzFees = Number(o.amazonfees) || 0
  const ebayFees = Number(o.ebayfees) || 0

  return price + shipping - cost - amzFees - ebayFees - actualShipping
})


const marketplaceUrl = computed(() => {
  if (marketplace.value === 'Amazon') {
    return `https://www.amazon.com/dp/${orderData.value.listingid}`
  } else if (marketplace.value === 'eBay') {
    return `https://ebay.com/itm/${orderData.value.listingid}`
  } else if (marketplace.value === 'Walmart') {
    return `https://www.walmart.com/ip/${orderData.value.listingid}`
  }
  return ''
})

// Compute if order is older than 6 days
const isOld = computed(() => {
  const createdDate = new Date(props.order.CreatedDate)
  const sixDaysAgo = new Date()
  sixDaysAgo.setDate(sixDaysAgo.getDate() - 6)
  return createdDate < sixDaysAgo
})

// Update handler with debouncing
let updateTimeout = null
const handleFieldUpdate = async () => {
  if (loading.value) return

  if (updateTimeout) {
    clearTimeout(updateTimeout)
  }

  updateTimeout = setTimeout(async () => {
    loading.value = true
    try {
      await salesService.updateSale(orderData.value.ID, orderData.value)
    } catch (err) {
      console.error('Error updating order:', err)
      orderData.value = { ...props.order }
      emit('update-error', {
        orderId: orderData.value.ID,
        error: err.message
      })
    } finally {
      loading.value = false
    }
  }, 500)
}

const assignEbayOrderToVendor = async () => {
  if (!newVendor.value || !partNumber.value) {
    emit('update-error', {
      error: 'Please provide both vendor and part number'
    })
    return
  }
  
  loading.value = true
  try {
    await orderService.assignEbayOrder(
      newVendor.value,
      orderData.value.ID,
      partNumber.value
    )
    
    // Remove order from store after successful assignment
    emit('order-assigned', orderData.value.ID)
    
  } catch (err) {
    console.error('Error assigning order:', err)
    emit('update-error', {
      error: 'Failed to assign order to vendor'
    })
  } finally {
    loading.value = false
  }
}
</script> 